import React, { useEffect, useState } from 'react'

import locationIcon from '../../../assets/svgs/location.svg'

import { t } from 'i18next'
import { NotificationManager } from 'react-notifications'
import Cookies from 'universal-cookie'
import GenericModal from '../../../components/generic-modal'
import MarketingService from '../../../services/marketingService'
import { KEYS } from '../../../utils/storage'
import CouponsForm from './coupons-form'

export const couponsModalText = (text) =>
	t(`marketing.promotions.CouponModal.${text}`)

export default function CouponModal({ showModal, data, onClose }) {
	const [visible, setVisible] = useState(false)
	const [loading, setLoading] = useState(false)
	const [state, setState] = useState({})

	const cookies = new Cookies()
	const venueType = cookies.get(KEYS.VENUE_TYPE)

	useEffect(() => {
		if (showModal) {
			if (data?.id != null) {
				const formattedData = {
					id: data.id,
					code: data.code,
					description: data.description,
					discount_type: data.financial.discount_type,
					discount_amount: data.financial.discount_amount,
					selected_product: data.financial.product,
					usage_limit_per_coupon: data?.financial?.usage_limit_per_coupon,
					selected_customer: data.financial.user,
					minimum_spent: data?.financial?.minimum_spent,
					start_time: data?.start_time,
					expiry_time: data?.expiry_time
				}

				setState(formattedData)
			}
		}
		setVisible(showModal)
	}, [showModal])

	const handleChangeType = (value) => {
		setState((v) => ({ ...v, discount_type: value.target.value }))
	}

	const handleChangeStart = (value) => {
		setState((v) => ({ ...v, start_time: value }))
	}

	const handleChangeEnd = (value) => {
		setState((v) => ({ ...v, expiry_time: value }))
	}

	const handleChangeSelectedProduct = (value) => {
		// Store the full object for selected product
		setState((v) => ({
			...v,
			selected_product: {
				id: value?.value || null,
				title: value?.label || ''
			}
		}))
	}

	const handleChangeSelectedCustomer = (value) => {
		// Store the full object for selected customer
		setState((v) => ({
			...v,
			selected_customer: {
				id: value?.value || null,
				name: value?.label || ''
			}
		}))
	}

	const onSubmit = () => {
		const { discount_type, discount_amount, start_time, expiry_time } = state

		if (!discount_type) {
			NotificationManager.warning(couponsModalText('discount_type_required'))
			return
		}
		if (!discount_amount) {
			NotificationManager.warning(couponsModalText('discount_amount_required'))
			return
		}
		if (!start_time) {
			NotificationManager.warning(
				couponsModalText('discount_start_time_required')
			)
			return
		}
		if (!expiry_time) {
			NotificationManager.warning(
				couponsModalText('discount_end_time_required')
			)
			return
		}

		// Create a payload with safe access to properties
		if (state.id) {
			const payload = {
				id: state.id,
				code: state.code,
				description: state.description,
				discount_type: state.discount_type,
				discount_amount: state.discount_amount,
				// Safely access selected_product id
				selected_product: state.selected_product && state.selected_product.id !== undefined ?
					state.selected_product.id :
					null,
				usage_limit_per_coupon: state?.usage_limit_per_coupon,
				// Safely access selected_customer id
				selected_customer: state.selected_customer && state.selected_customer.id !== undefined ?
					state.selected_customer.id :
					null,
				minimum_spent: state?.minimum_spent,
				start_time: state?.start_time,
				expiry_time: state?.expiry_time
			}

			setLoading(true);
			MarketingService.UpdateCoupon(payload)
				.then((res) => {
					setLoading(false);
					onClose(true)
				})
				.catch((err) => {
					setLoading(false);
					if (typeof err?.error === 'string') {
						NotificationManager.error(err?.error)
					} else {
						const errorKeys = Object.keys(err?.error || {})
						if (errorKeys.length > 0) {
							const firstErrorKey = errorKeys[0]
							const firstErrorMessage = err?.error[firstErrorKey][0]
							NotificationManager.error(
								firstErrorMessage || t('common.error_generic')
							)
						} else {
							NotificationManager.error(t('common.error_generic'))
						}
					}
				})
		} else {
			// Create a safe copy of state for the create operation
			const createPayload = {
				...state,
				// Safely access selected_product id
				selected_product: state.selected_product && state.selected_product.id !== undefined ?
					state.selected_product.id :
					null,
				// Safely access selected_customer id
				selected_customer: state.selected_customer && state.selected_customer.id !== undefined ?
					state.selected_customer.id :
					null,
			};

			setLoading(true);
			MarketingService.CreateCoupon(createPayload)
				.then((res) => {
					setLoading(false);
					onClose(true)
				})
				.catch((err) => {
					setLoading(false);
					if (typeof err?.error === 'string') {
						NotificationManager.error(err?.error)
					} else {
						const errorKeys = Object.keys(err?.error || {})
						if (errorKeys.length > 0) {
							const firstErrorKey = errorKeys[0]
							const firstErrorMessage = err?.error[firstErrorKey][0]
							NotificationManager.error(
								firstErrorMessage || t('common.error_generic')
							)
						} else {
							NotificationManager.error(t('common.error_generic'))
						}
					}
				})
		}
	}

	const isRetail = () => {
		return (
			venueType === 'sport_essentials' ||
			venueType === 'pharmacy' ||
			venueType === 'home_decor' ||
			venueType === 'fashion_threads'
		)
	}

	const isVenueTypeOnlineShop = () => {
		return venueType === 'online_shop'
	}

	const title =
		(data?.id != null ? couponsModalText('edit') : couponsModalText('new')) +
		' ' +
		couponsModalText('coupon')

	return (
		<div>
			<GenericModal
				children={
					<CouponsForm
						{...{
							handleChangeEnd,
							handleChangeStart,
							handleChangeType,
							isRetail,
							setState,
							state,
							isVenueTypeOnlineShop,
							handleChangeSelectedProduct,
							handleChangeSelectedCustomer
						}}
					/>
				}
				icon={locationIcon}
				open={visible}
				{...{ onClose, onSubmit, title, loading }}
				saveText={
					state.id ? couponsModalText('update') : couponsModalText('create')
				}
			/>
		</div>
	)
}